import appService from "./service";
import { EncryptJSON, DecryptJSON } from "app/utils/crypto";

const nodeFDQN = process.env.REACT_APP_DAAS_WSG;
const deviceId = "urn:uuid:" + appService.generateGuid();
const REACT_APP_T_MOBILE = process.env.REACT_APP_T_MOBILE?.split(",").find(
  (origin: string) => origin === window.location.origin
);
//console.warn('redirect url : ',REACT_APP_T_MOBILE )
const loginRedirect =
  process.env.REACT_APP_LOGIN_ENDPOINT +
  "?response_type=code&redirect_uri=" +
  REACT_APP_T_MOBILE +
  "&client_id=DIGITS_PORTAL&scope=TMO_ID_profile+associated_lines+billing_information+token_validation+permission+openid";
const TIME_OUT_VALUE = 10000;
export interface Data {
  accessToken: string;
  refreshToken: string;
  expire_time: number;
  id_token: string;
}

export interface RootObject {
  returnCode: string;
  status: string;
  data: Data;
}
export interface httpInterface {
  tryCount: number;
  url: string;
  options: any;
  fetch: any;
}
declare global {
  interface Window {
    LoggingSDK?: any;
  }
}

const LoggingSDK1 = new window.LoggingSDK.Logging();
const metadataBuilder = new window.LoggingSDK.LogMetadataBuilder();
LoggingSDK1.setUserInfo({
  partnerID: "101",
  endpointUrl: process.env.REACT_APP_LOG_ENDPOINT,
  idToken: sessionStorage.getItem("idToken") || null,
});

class HTTPClass {
  tryCount: number;
  url: string;
  options: any;
  actionMaster: any;

  constructor(url: string, options: any, actionMaster: any) {
    this.tryCount = 1;
    this.url = url;
    this.options = options;
    this.actionMaster = actionMaster;
  }

  async fetch(): Promise<any> {
    const metadata = metadataBuilder
      .action(this.actionMaster)
      .category("user")
      .clientData(
        JSON.stringify({
          ...this.options,
          apiurl: this.url,
          network: REACT_APP_T_MOBILE,
        })
      )
      .build();
    LoggingSDK1.setUserInfo({ email: appService.accountEmail });
    const res = await window
      .fetch(this.url, this.options)
      .then((response) => {
        metadata.clientData = JSON.stringify({
          ...this.options,
          apiurl: this.url,
          apiReturnCode: response.status,
        });
        
        let contentType = response.headers ? response.headers.get("Content-Type") || "" : '';
        if (contentType.includes("xml")) {
          return response.text();
        }
        if (contentType === "") {
          return new Promise((res) => res(response));
        }
        if (response.status === 401) {
          throw new Error("401");
        }

        //Start To DO once response returns from below APIs remove below code
        if (response.status === 200) {
        if(this.url.includes("permissionManagement/grant") || this.url.includes("/permissionManagement/revoke")){          
          return {status:200} 
          }
        }
        //End
        return response.json();
      })
      .then((data:any) => {
        if (this.actionMaster.toLowerCase() === "fetch user info") {
          LoggingSDK1.setUserInfo({ email: data.TMO_ID_profile.email });
          appService.setAccountEmail(data.TMO_ID_profile.email);
        }
        if (
          data.error ||
          data.errorCode ||
          data.errorMsg ||
          (data?.returnCode &&
            data?.returnCode !== "200" &&
            data?.returnCode !== "202")
        ) {
          // we can not logging error here since few apis might return 404 when use has no lines in account or user don't have any data on line delve page.
          LoggingSDK1.event("Error", metadata);
          return { errors: true, ...data };
        }
        LoggingSDK1.event("", metadata);
        return data;
      })
      .catch((e) => {
        LoggingSDK1.error("", metadata);
        return { errors: true, e };
      });

    if (res.errors) {
      LoggingSDK1.event("", metadata);
      if (
        this.actionMaster.toLowerCase() === "validate daas token" ||
        this.actionMaster.toLowerCase() === "refresh daas token" ||
        this.actionMaster.toLowerCase() === "register token"
      ) {
        return res;
      } else if (res.e === "401" || res.e === 401) {
        DAASLAYER.validateDaasToken();
        return res;
      } else if (this.tryCount <= 2) {
        this.tryCount++;
        return await this.fetch();
      }
      return res;
    } else {
      return res;
    }
  }
}
const daas_layer = function (this: any) {
  let sessionAuthData = () => {
    try {
      return DecryptJSON(sessionStorage.getItem("authInfo"));
    } catch (e) {
      sessionStorage.removeItem("authInfo");
      sessionStorage.removeItem("device_id");
      window.location.href = loginRedirect;
      return false;
    }
  };
  const apis = {
    getToken: nodeFDQN + "/getToken",
    validateToken: nodeFDQN + "/validateDaasToken",
    refreshToken: nodeFDQN + "/refreshToken",
  };
  const config: any = {
    headers: () => {
      return {
        cdrInfo: "daasreg",
        daasClientId: "DAAS_PORTAL",
        "client-type": "cDigits",
        "Unique-Session-Number": sessionStorage.getItem("usn"),
        "Content-Type": "application/json",
        device_id: deviceId,
        daasAccessToken: sessionAuthData()?.data?.accessToken || null,
      };
    },
    authInfo: {
      returnCode: "200",
      status: "SUCCESS",
      data: {
        accessToken: sessionAuthData()?.data?.accessToken || null,
        refreshToken: sessionAuthData()?.data?.refreshToken || null,
        expire_time: 1638315528,
      },
    },
    userInfo: {},
    userLines: {},
  };

  function timeout(ms: any, promise: any) {
    return new Promise((resolve, reject) => {
      const timer = setTimeout(() => {
        reject(new Error("TIMEOUT"));
      }, ms);

      promise
        .then((reason: any) => {
          clearTimeout(timer);
          resolve(reason);
        })
        .catch((reason: any) => {
          clearTimeout(timer);
          reject(reason);
        });
    });
  }

  this.HTTP = async (
    url = "",
    type = "POST",
    actionMaster = "",
    payload = {} || null,
    extraHeaders = {},
    xml_payload = "",
    onlyExternalHeaders = false
  ) => {
    let headers = () => {
      if (extraHeaders) {
        if (onlyExternalHeaders) {
          return {
            ...extraHeaders,
          };
        }
        return {
          ...config.headers(),
          ...extraHeaders,
        };
      }
      return config.headers();
    };
    let xml_headers = () => {
      if (extraHeaders) {
        return {
          ...config.xmlHeaders,
          ...extraHeaders,
        };
      }
      return config.xmlHeaders;
    };
    let options: RequestInit = {
      method: type,
      headers: headers(),
    };
    if ((type === "POST" || type === "PUT") && payload) {
      options = {
        method: type,
        headers: headers(),
        body: JSON.stringify(payload),
      };
    }
    if ((type === "POST" || type === "PUT") && xml_payload) {
      options = {
        method: type,
        headers: { ...headers(), ...xml_headers() },
        body: xml_payload,
      };
    }
    return await timeout(
      TIME_OUT_VALUE,
      new HTTPClass(url, options, actionMaster.toLowerCase()).fetch()
    )
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        console.log(error);
        return error;
      });
    //return await new HTTPClass(url, options, actionMaster).fetch();
  };

  this.registerToken = async (code: string) => {
    let authCount = sessionStorage.getItem("authCount") || 0;
    if (!sessionAuthData().data && code === "") {
      window.location.href = loginRedirect;
      return null;
    }
    // const authToken = sessionStorage.getItem('token') || null;

    // if(authToken === null) {
    //   window.location.href = loginRedirect;
    //   return;
    // }
    authCount = +authCount;
    if (sessionAuthData().data && !code) {
      sessionStorage.setItem("authCount", `${++authCount}`);
      let response = await this.validateDaasToken();
      if (response.errors) {
        sessionStorage.removeItem("authInfo");
        sessionStorage.removeItem("device_id");
        window.location.href = loginRedirect;
        return null;
      } else {
        sessionStorage.setItem("authCount", `0`); 
      }
    } else {
      let response = await this.HTTP(
        apis.getToken,
        "POST",
        "register token",
        null,
        {
          authCode: code,
          "redirect-uri": REACT_APP_T_MOBILE,
        }
      );

      if (!response.errors) {
        let tokenInfo: RootObject = response;
        config.authInfo = tokenInfo;
        config.headers.daasAccessToken = tokenInfo.data?.accessToken;
        config.headers["Unique-Session-Number"] = sessionStorage.getItem("usn");
        sessionStorage.setItem("authInfo", EncryptJSON(tokenInfo));
        sessionStorage.setItem("authCount", "0");
        sessionStorage.setItem("idToken", tokenInfo.data?.id_token);
        LoggingSDK1.setUserInfo({
          partnerID: "101",
          idToken: tokenInfo.data?.id_token,
        });
      } else {
        if (authCount >= 3) {
          return response;
        } //else {
          sessionStorage.setItem("authCount", `${++authCount}`);
        //}
        window.location.href = loginRedirect;
        return null;
      }
      return response;
    }
    return true;
  };
  this.validateDaasToken = async () => {
    let response = await this.HTTP(
      apis.validateToken,
      "POST",
      "validate daas token"
    );
    if (response.errors) {
      setTimeout(() => {
        this.refreshToken();
      }, 3000);
      return this.refreshToken();
    } else {
      return response;
    }
  };
  this.refreshToken = async () => {
    let response = await this.HTTP(
      apis.refreshToken,
      "POST",
      "refresh daas token",
      null,
      {
        daasRefreshToken: config.authInfo?.data?.refreshToken,
      }
    );
    if (response.errors) {
      sessionStorage.removeItem("authInfo");
      window.location.href = loginRedirect;
    } else {
      let tokenInfo: Data = response;
      config.authInfo.data = tokenInfo;
      config.headers.daasAccessToken = tokenInfo.accessToken;
      sessionStorage.setItem("authInfo", EncryptJSON(tokenInfo));
      sessionStorage.setItem("idToken", response.data?.id_token);
      LoggingSDK1.setUserInfo({
        partnerID: "101",
        idToken: response.data?.id_token,
      });
    }
    return response;
  };

  this.redirectToLoginPage = () => {
    window.location.href = loginRedirect;
  };
};
const DAASLAYER = new (daas_layer as any)();
export default DAASLAYER;
